import React from 'react';
import { graphql } from 'gatsby';

import CategoryBanner from '../components/CategoryBanner/CategoryBanner';
import Goods from '../components/Goods/Goods';
import Seo from '../components/SEO/SEO';
import Subheader from '../components/Subheader/Subheader';

import { ISubCategoriesProps } from './Types';

import { TRANSLATE, LANGUAGES } from '../constants/languages';

const SubCategory: React.FC<ISubCategoriesProps> = ({ data }): JSX.Element => {
  const {
    allCockpitProduct: { nodes },
    cockpitSubCategories: {
      category: {
        value: {
          link: { value: categoryLink },
          title: { value: categoryTitle },
        },
      },
      videoLink,
      metaDescription,
      metaTitle,
      description: { value: descriptionValue },
      image: {
        value: {
          childImageSharp: { fluid },
        },
      },
      lang,
      priceList,
      link: { value: linkValue },
      title: { value: titleValue },
    },
  } = data;

  const crumbs = [
    {
      title: TRANSLATE[lang as 'ru' | 'ua'].primaryPage,
      link: '/',
    },
    {
      title: 'Каталог',
      link: '/catalog',
    },
    {
      title: categoryTitle,
      link: categoryLink,
    },
    {
      title: titleValue,
      link: linkValue,
    },
  ];

  console.log(metaDescription);
  return (
    <div className="big-container catalog-page">
      <Seo
        breadcrumbs={crumbs}
        description={metaTitle?.value || descriptionValue}
        lang={lang as 'ru' | 'ua'}
        path={linkValue}
        title={metaTitle?.value || titleValue}
      />
      <Subheader crumbs={crumbs} />
      <CategoryBanner description={descriptionValue} fluid={fluid} title={titleValue} priceList={priceList?.value.publicURL || null} />
      <Goods goods={nodes} subcategoryLink={linkValue} />
      {/* {videoLink && videoLink.value && (
        <div className="catalog-page-video-wrapper">
          <iframe className="catalog-page-video" title="Catalog video" src={videoLink.value} />
        </div>
      )} */}
    </div>
  );
};

export const query = graphql`
  query($path: String!) {
    cockpitSubCategories(link: { value: { eq: $path } }, lang: { ne: "any" }) {
      category {
        value {
          link {
            value
          }
          title {
            value
          }
        }
      }
      description {
        value
      }
      metaTitle {
        value
      }
      metaDescription {
        value
      }
      priceList {
        value {
          publicURL
        }
      }
      image {
        value {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      lang
      link {
        value
      }
      title {
        value
      }
      videoLink {
        value
      }
    }
    allCockpitProduct(
      sort: { order: ASC, fields: name___value }
      filter: { subcategory: { value: { link: { value: { eq: $path } } } }, lang: { eq: "ua" } }
    ) {
      nodes {
        lang
        id
        link {
          value
        }
        name {
          value
        }
        description {
          value
        }
        productAvailable {
          value
        }
        measurment {
          value
        }
        measurment2 {
          value
        }
        measurment3 {
          value
        }
        measurment4 {
          value
        }
        price {
          value
        }
        price2 {
          value
        }
        price3 {
          value
        }
        price4 {
          value
        }
        stock {
          value
        }
        brand {
          value
        }
        specifications {
          value {
            data
          }
        }
        code {
          value
        }
        image {
          value {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        images {
          value {
            id
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        subcategory {
          value {
            title {
              value
            }
            link {
              value
            }
            category {
              value {
                title {
                  value
                }
                link {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default SubCategory;
